enum ItemKey {
    BlackChip = "black poker chip"
    , BlueChip = "blue poker chip"
    , Bricabrac = "bric-a-brac"
    , Chest = "chest"
    , CoffeeCup = "coffee cup"
    , Coin = "coin"
    , Cowskin = "cowskin rug"
    , Cup = "cup"
    , Cupboard = "cupboard"
    , CupboardKey = "small key"
    , Cushion = "cushion"
    , DeerHeadStatue = "deer head statue"
    , DeerHorn = "deer horn"
    , Earl = "earl"
    , Firepit = "firepit"
    , Fish = "fish"
    , Fountain = "fountain"
    , Fridge = "fridge"
    , GarageDoor = "garage door"
    , Gate = "gate"
    , GreenChip = "green poker chip"
    , Headset = "headset"
    , Ice = "ice"
    , IceMaker = "ice maker"
    , Kayak = "kayak"
    , Lime = "lime"
    , Marg = "marg"
    , Note = "note"
    , OkayStatue = "okay statue"
    , OrnateKey = "ornate key"
    , Ottoman = "ottoman"
    , Papers = "papers"
    , PeaceStatue = "peace statue"
    , Pool = "pool"
    , Porn = "porn"
    , Pouch = "pouch"
    , Powerdot = "powerdot"
    , RedChip = "red poker chip"
    , RetirementParty = "retirement party"
    , Robe = "cowskin robe"
    , Rope = "rope"
    , RugroomBook = "blue book"
    , RugroomBookcase = "bookcase"
    , SkeweredEarl = "skewered earl"
    , Snacks = "snacks"
    , Snorkel = "snorkel"
    , Tequila = "tequila"
    , Thievery = "thievery"
    , ThumbStatue = "thumb statue"
    , TripleSec = "triple sec"
    , UndecidedBook = "yellow book"
    , UndecidedBookcase = "bookcase"
    , Vitamix = "vitamix"
    , WhiteChip = "white poker chip"
}

export default ItemKey;